var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWpfSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wpf:survey",
    clipPath: "url(#clip0_0_369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.45714 -4.14689e-05C7.26112 0.0372421 7.08457 0.142605 6.95869 0.297435C6.83282 0.452265 6.76571 0.6466 6.76922 0.846112V1.69227H3.72814C3.05122 1.69227 2.53845 2.20504 2.53845 2.88196V20.7307C2.53845 21.4923 3.05122 22 3.72814 22H18.1923C18.8692 22 19.382 21.4872 19.382 20.8103V2.88196C19.4666 2.20504 18.9488 1.69227 18.2718 1.69227H15.2308V0.846112C15.2308 0.621698 15.1416 0.406476 14.9829 0.247791C14.8242 0.0891066 14.609 -4.14689e-05 14.3846 -4.14689e-05H7.61538C7.58888 -0.00128826 7.56233 -0.00128826 7.53584 -4.14689e-05C7.50934 -0.00128826 7.48364 -0.00128826 7.45714 -4.14689e-05ZM8.46153 1.69227H13.5385V3.38457H8.46153V1.69227ZM4.23076 3.38457H6.76922V4.23073C6.76922 4.45514 6.85837 4.67036 7.01705 4.82905C7.17574 4.98773 7.39096 5.07688 7.61538 5.07688H14.3846C14.609 5.07688 14.8242 4.98773 14.9829 4.82905C15.1416 4.67036 15.2308 4.45514 15.2308 4.23073V3.38457H17.7692V20.3076H4.23076V3.38457ZM5.92307 7.61534V11H9.30768V7.61534H5.92307ZM6.76922 8.4615H8.46153V10.1538H6.76922V8.4615ZM11 8.4615V10.1538H16.0769V8.4615H11ZM5.92307 12.6923V16.0769H9.30768V12.6923H5.92307ZM11 13.5384V15.2307H16.0769V13.5384H11Z",
    fill: "#056E9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpfSurvey);
export default __webpack_public_path__ + "static/media/wpf_survey.a66ec75d3454dc1df6a89c301a062ccb.svg";
export { ForwardRef as ReactComponent };